import { Injectable } from "@angular/core";
import { environment } from "../../environments/environment";

@Injectable({
    providedIn: 'root',
})

export class ServiceBase {
	/** URL pour le webService */
	public apiUrl;

	/**
	 * Constructeur
	 */
	constructor() {
		if (environment.production) {
			this.apiUrl = "";
		} else {
			this.apiUrl = environment.apiUrl;
		}
	}
}
